import SearchForm from '../../model/search-form';

export default class TireWarrantySearchForm implements SearchForm {
  private readonly dateFrom: JQuery;
  private readonly dateUntil: JQuery;
  private readonly submitFormButton: JQuery;
  private readonly isForDraftWarranties: boolean; // Allow submit empty form

  constructor(private form: JQuery<HTMLFormElement>) {
    this.dateFrom = form.find('.js-dateFrom');
    this.dateUntil = form.find('.js-dateUntil');
    this.submitFormButton = form.find('.js-submitForm');
    this.isForDraftWarranties = form.data('draft-warranties') as boolean;

    this.bindFormValidation();
    this.submitFormButton.prop('disabled', !this.isFormValid());
  }

  getForm(): JQuery<HTMLFormElement> {
    return this.form;
  }

  submit(): void {
    this.form.submit();
  }

  private bindFormValidation(): void {
    this.form.on('input change', () => {
      this.submitFormButton.prop('disabled', !this.isFormValid());
    });
  }

  isFormValid(): boolean {
    if (this.dateFrom.val() !== '' && this.dateUntil.val() === '') {
      return false;
    }
    if (this.isFormEmpty() && !this.isForDraftWarranties) {
      return false;
    }

    return true;
  }

  private isFormEmpty(): boolean {
    let valueFound = false;
    // eslint-disable-next-line consistent-return
    this.form.find('input[type="text"]:not(:disabled), select').each((i, el) => {
      // eslint-disable-next-line eqeqeq
      if ($(el).val() != '' && $(el).val() != null) {
        valueFound = true;
        return false; // break $.each loop
      }
    });
    return !valueFound;
  }
}
